import { TranslateResult } from 'vue-i18n';
import { Contact, IAgent } from '@/types';

export function getContactName(
  contact: Contact,
  translate?: (s: string) => TranslateResult
) {
  const { name, emails = [], phoneNumbers = [], firstName, lastName } = contact;
  const fullName = firstName && lastName
    ? `${firstName} ${lastName}`
    : firstName || lastName || name || '';

  const $t = translate || ((s: string) => s);
  return fullName
    || phoneNumbers.length && phoneNumbers[0]
    || emails.length && emails[0]
    || $t('HITL.common.labels.default-contact-name') as string;
}

export function getAgentName(
  agent: IAgent,
  translate?: (s: string) => TranslateResult
) {
  const { email } = agent;
  const { firstName, lastName } = agent.data || {};

  const name = firstName && lastName
    ? `${firstName} ${lastName}`
    : firstName || lastName || '';
  const identifier = name || email;

  const $t = translate || ((s: string) => s);
  return identifier || ($t('hitl.common.defaultAgentName') as string);
}
